module.exports = function(array, item) {
  return array.indexOf(item) !== -1;
};
